import React from "react";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
import { TermsandConditionPopup } from "./../../termsAndConditions/TermsandConditionPopup";
import { NextButtonTermsAndCondition } from "./../../termsAndConditions/NextButtonTermsAndCondition";
// import Switch from "react-switch";

export const MainSubscriptionScreen = ({
  open,
  onOpenModal,
  onCloseModal,
  handleChecked,
  termsConditionDisabled,
  successPopupClick,
  successPopupOpenModal,
  onCloseModalSuccess,

  onPageChangeHandlerClosed,
  onClick,
  displayScreen,
  seating,
  scanAndPay,
  menuSetup,
  ordering,
  fastFoodMenuSetup,
  fastFoodOrdering,
  seatingAreaButton,
  scanAndPayButton,
  menuSetupButton,
  orderingButton,
  foodMenuSetupButton,
  foodOrderingButton,
  walkinWaitlistButton,
  reservationButton,
  takeAwayButton,
  selfServeButton,
  driveThruButton,
  curbSideButton,
  onsubmitData,
}) => {
  return (
    <React.Fragment>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div className="subscription_component_onboarding_main ">
        <div className="subscription-main-screen-box justify-content-center mb-4 mt-3">
          <div className="subscription-menu-one mr-5" onClick={onClick}>
            <div
              className={
                displayScreen === false
                  ? "subscription-menu-one-imageBox subscription-menu-one-imageBox-active"
                  : "subscription-menu-one-imageBox"
              }
            >
              <Image
                src={
                  displayScreen === false
                    ? require("../../../../../../assets/images/onboarding/orderingWhite.png")
                    : require("../../../../../../assets/images/onboarding/orderingRed.png")
                }
                fluid
                alt="icon"
                title="Subscription Icon"
              />
            </div>
            <h5>Casual/Fine Dining</h5>
            <hr
              className={
                displayScreen === false ? "Casual-fine-dining" : "d-none"
              }
            />
          </div>
          <div className="subscription-menu-one" onClick={onClick}>
            <div
              className={
                displayScreen === true
                  ? "subscription-menu-one-imageBox subscription-menu-one-imageBox-active"
                  : "subscription-menu-one-imageBox"
              }
            >
              <Image
                src={
                  displayScreen === true
                    ? require("../../../../../../assets/images/onboarding/orderingWhite.png")
                    : require("../../../../../../assets/images/onboarding/orderingRed.png")
                }
                fluid
                alt="icon"
                title="Subscription Icon"
              />
            </div>
            <h5>Fast Food and other</h5>
            <hr
              className={
                displayScreen === true ? "Casual-fine-dining" : "d-none"
              }
            />
          </div>
        </div>
        <div className="subscription-main-screen-box-Two margin-bottom-chains-onboarding">
          {displayScreen === false ? (
            <div>
              <div className="section-one-align">
                <h5>Seating</h5>
                {seating}
              </div>
              {/* <div className="section-one-align">
                <h5>Scan & Pay (Touchless)</h5>
                {scanAndPay}
              </div> */}
              <div className="section-one-align">
                <h5>Menu Set Up</h5>
                {menuSetup}
              </div>
              <div className="section-one-align">
                <h5>Ordering</h5>
                {ordering}
              </div>
            </div>
          ) : (
            <div>
              <div className="section-one-align">
                <h5>Menu Set Up</h5>
                {fastFoodMenuSetup}
              </div>
              <div className="section-one-align">
                <h5>Ordering</h5>
                {fastFoodOrdering}
              </div>
            </div>
          )}
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            onClick={onPageChangeHandlerClosed}
          />
          {seatingAreaButton === true ||
          scanAndPayButton === true ||
          menuSetupButton === true ||
          orderingButton === true ||
          foodMenuSetupButton === true ||
          foodOrderingButton === true ||
          walkinWaitlistButton === true ||
          reservationButton === true ||
          takeAwayButton === true ||
          selfServeButton === true ||
          driveThruButton === true ||
          curbSideButton === true ? (
            <TermsandConditionPopup
              open={open}
              onOpenModal={onOpenModal}
              // onsubmitData
              onCloseModal={onCloseModal}
              handleChecked={handleChecked}
              termsConditionDisabled={termsConditionDisabled}
              successPopupClick={successPopupClick}
              successPopupOpenModal={successPopupOpenModal}
              onCloseModalSuccess={onCloseModalSuccess}
            />
          ) : (
            // <NextButtonTermsAndCondition
            //   open={open}
            //   onOpenModal={onOpenModal}
            //   onCloseModal={onCloseModal}
            //   handleChecked={handleChecked}
            //   termsConditionDisabled={termsConditionDisabled}
            //   successPopupClick={successPopupClick}
            //   successPopupOpenModal={successPopupOpenModal}
            //   onCloseModalSuccess={onCloseModalSuccess}
            // />

            <TermsandConditionPopup
              open={open}
              onOpenModal={onOpenModal}
              // onsubmitData
              onCloseModal={onCloseModal}
              handleChecked={handleChecked}
              termsConditionDisabled={termsConditionDisabled}
              successPopupClick={successPopupClick}
              successPopupOpenModal={successPopupOpenModal}
              onCloseModalSuccess={onCloseModalSuccess}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
